<div id="vap-component" (window:beforeunload)="ngOnDestroy()" class="volumeAtPriceComponent">
  <div class="component-header">
    <span id="title">VOLUME POR PREÇO</span>
    <div class="icons gridster-ignore-drag">
      <mat-icon id="ico-expand" *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()">
      </mat-icon>
      <mat-icon disableWksChange id="ico-close" *ngIf="!newWindow" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="container-fluid gridster-ignore-drag">
    <app-auction-hammer *ngIf="auctionHammer" [timeToOpen]="timeToOpen" [priceTheory]="priceTheory"
      [varTheory]="varTheory">
    </app-auction-hammer>
    <app-asset-input-header [symbolAutoComplete]="symbol" (onsymbolChanged)="selectAsset($event)"
      [lastTrade]="lastTrade" [coinVariation]="coinVariation" [showVariation]="showVariation"
      [hiddenInvalid]="hiddenInvalid" [variation]="variation" [dateLastNegotiation]="messageQuote.dateLastNegotiation"
      [hourLastTrade]="messageQuote.hourLastTrade" [timeUpdate]="messageQuote.timeUpdate" [company]="company"
      [image]="imgName"></app-asset-input-header>
    <div class="pressure-bar-container">
      <div id="pressure-bar" class="pressure-bar" [style.background]="classPressure"></div>
      <div class="volume-container">
        <span id="buy-percentage">{{ percentageBuy/100 | percent:'1.2':'pt' }}</span>
        <span id="sell-percentage">{{ percentageSell/100 | percent:'1.2':'pt' }}</span>
      </div>
    </div>
    <div *ngIf="hiddenInvalid" class="no-data-msg">{{ msgNoData }}</div>
    <div *ngIf="!hiddenInvalid" class="data-container">
      <div class="row pl-1">
        <div *ngFor="let item of period"
          [ngClass]="{'rectangle-active' : item.selected, 'rectangle-inactive' : !item.selected}"
          (click)="onChangePeriod(item)">
          <div id="{{ 'tab-period-' + item.description }}" class="period">
            {{ item.description }}
          </div>
        </div>
      </div>
      <div class="divisor"></div>
      <div *ngIf="loading" class="spinner">
        <app-spinner-loading></app-spinner-loading>
      </div>
      <!--TABLE-->
      <div *ngIf="!loading" class="row data-grid">
        <div class="header-table">
          <div class="line">
            <th class="priceLabel">PREÇO</th>
            <th class="volumeLabel">VOLUME</th>
            <th class="barLabel">BARRA DE VOLUME</th>
            <th class="balanceLabel">SALDO</th>
          </div>
        </div>
        <div #scrollableDiv class="col-12 scrollable" [ngClass]="{'theory': auctionHammer}">
          <div class="empty" *ngIf="showEmpty">Não há dados do ativo.</div>
          <table class="table-striped table-hovered">
            <tbody>
              <tr *ngFor="let row of rowOffersData; let index=index;">
                <td class="price letter-align tooltip-cell {{row.class}}" matTooltipPosition="above"
                  matTooltip="{{row.tooltipTitle}}">
                  <span>{{ row.price }}</span>
                </td>
                <td class="volume padding-number">{{ row.totalVolume }}</td>
                <td class="bar">
                  <div class="bar-volume" [style.width]="((row.totalVolumeUnformatted * 100) / maxVolume) + '%'">
                    <div class="bar-volume-buyer" [ngStyle]="row?.classBarVolumeWidthOfBuyer">
                    </div>
                    <div class="bar-volume-seller" [ngStyle]="row?.classBarVolumeWidthOfSeller">
                    </div>
                    <div class="bar-volume-direct" [ngStyle]="row?.classBarVolumeWidthOfDirect">
                    </div>
                    <div class="bar-volume-undetermined" [ngStyle]="row?.classBarVolumeWidthOfUndetermined">
                    </div>
                  </div>
                </td>
                <td class="balance padding-number"
                  [ngClass]="{'balance-positive': row.balance > 0, 'balance-negative': row.balance < 0}">
                  {{ row.balance | number:'1.2-2':'pt' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="component-footer">
    <span *ngIf="!showEmpty">Última atualização: {{ timeUpdate ? timeUpdate : "-" }}</span>
  </div>
</div>
<div (window:beforeunload)="closeSheet()"></div>
